"use strict";

class CustomerAgentListController {

    constructor($scope, SSHttpService, SSUtilService, $timeout, SSEoiService, SSAwsService, SSAlertService, SSAppService, SSUserService) {
    	const self = this;

        self.$scope = $scope;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.$timeout = $timeout;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        
        self.data = SHOWSUITE.data;
        self.init();
    }

    init() {
    	const self = this;

        self.apiOffset = 0;
        self.apiLimit = 10;
        self.selectedPage = 1;

        self.getAgentList();
    }

    getAgentList(){
        const self = this;

        let url = 'brokers';
        let params = {
            offset: self.apiOffset,
            limit: self.apiLimit,
            send_total_count: true,
            include: 'user, agency'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (responseObj) {
          loading(false);
          if (responseObj instanceof Error) {
            self.SSAlertService.parseAndDisplayError(responseObj);
            let errorData = responseObj.data;
            return;
          }
          if(responseObj.data){
            self.agentList = responseObj.data.brokers;

            self.count = responseObj.data.count;
            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
            self.pagesArr = [];

            for (var i = 0; i < self.pages; i++) {
                self.pagesArr.push(i);
            }
          }
          console.log(self.agentList);
        });
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.getAgentList();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.getAgentList();
      }

    gotoPage(pageNum){
        const self = this;

        self.apiOffset = parseInt(pageNum) * self.apiLimit;
        self.getAgentList();
    }

}

CustomerAgentListController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', '$timeout', 'SSEoiService', 'SSAwsService', 'SSAlertService', 'SSAppService', 'SSUserService'];
app.controller('CustomerAgentListController', CustomerAgentListController);
